<div class="headline">
  <span>{{ 'general.rule-engine-headline-prefix' | translate }}</span>
  <coin-rule-engine-condition-picker
    [currentCondition]="ruleSet().condition"
    (changed)="setCondition($event)"></coin-rule-engine-condition-picker>
  <span>{{ 'general.rule-engine-headline-postfix' | translate }}</span>
  <div class="spacer"></div>
  @if (!ruleEngine.disabled()) {
    <button
      class="no-style delete"
      [disabled]="!deletable()"
      [matTooltipDisabled]="deletable()"
      [matTooltip]="'general.rule-tooltip' | translate"
      (click)="onDeleteClick()">
      <mat-icon>delete</mat-icon>
    </button>
  }
</div>

@for (ruleOrRuleSet of ruleSet().rules; track ruleOrRuleSet) {
  @if (isRuleSet(ruleOrRuleSet)) {
    <coin-lightweight-rule-set
      [nestingDepth]="nestingDepth() + 1"
      [deletable]="canDeleteItems"
      [ruleSet]="ruleOrRuleSet"
      (delete)="deleteItem(ruleOrRuleSet)"></coin-lightweight-rule-set>
  } @else {
    <coin-lightweight-rule
      [rule]="ruleOrRuleSet"
      [deletable]="canDeleteItems"
      (delete)="deleteItem(ruleOrRuleSet)"></coin-lightweight-rule>
  }
}
@if (!ruleEngine.disabled()) {
  <div class="buttons">
    <coin-v2-button
      icon="add"
      type="secondary"
      [text]="'general.add-sub-rule' | translate"
      (click)="addRule()"></coin-v2-button>
    @if (ruleEngine.allowRuleSets() === 'nested') {
      <coin-v2-button
        icon="add"
        type="secondary"
        [text]="'general.add-sub-rule-set' | translate"
        (click)="addRuleSet()"></coin-v2-button>
    }
  </div>
}
